// Types d'environnements supportés
type Environment = 'local' | 'preprod' | 'prod';

// Configuration pour chaque environnement
interface ApiConfig {
    host: string;
    port: string;
    notificationPort: string; // Port du service de notification
    secure: boolean; // Pour utiliser http ou https
}

// Définir les configurations pour chaque environnement
const configs: Record<Environment, ApiConfig> = {
    local: {
        host: 'localhost',
        port: '3000',
        notificationPort: '3008', // Port correct du service de notification
        secure: false
    },
    preprod: {
        host: 'api-preprod.inspecly.io', // À adapter selon votre domaine
        port: '443',
        notificationPort: '443', // En preprod/prod, probablement derrière un reverse proxy
        secure: true
    },
    prod: {
        host: 'api.inspecly.io', // À adapter selon votre domaine
        port: '443',
        notificationPort: '443', // En prod, probablement derrière un reverse proxy
        secure: true
    }
};

// Détermine l'environnement actuel à partir des variables d'environnement
const getEnvironment = (): Environment => {
    const env = process.env.REACT_APP_ENV || 'local';
    if (env === 'prod') return 'prod';
    if (env === 'preprod') return 'preprod';
    return 'local';
};

const getApiUrl = (): string => {
    // Si on a une URL complète en env var, l'utiliser directement
    if (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.startsWith('http')) {
        return process.env.REACT_APP_API_URL;
    }

    // Sinon, construire avec la config
    const env = getEnvironment();
    const config = configs[env];
    return `${config.secure ? 'https' : 'http'}://${config.host}${
        config.port === '443' || config.port === '80' ? '' : `:${config.port}`
    }`;
};

const getSocketUrl = (): string => {
    // Si on a une URL WebSocket complète en env var, l'utiliser directement
    if (process.env.REACT_APP_API_URL && process.env.REACT_APP_API_URL.startsWith('http')) {
        return process.env.REACT_APP_API_URL;
    }

    // Sinon, construire avec la config
    const env = getEnvironment();
    const config = configs[env];
    return `${config.secure ? 'https' : 'http'}://${config.host}${
        config.notificationPort === '443' || config.notificationPort === '80' ? '' : `:${config.notificationPort}`
    }`;
};
// Récupère la configuration pour l'environnement actuel
const currentEnv = getEnvironment();
const currentConfig = configs[currentEnv];
// Construit l'URL de l'API
export const API_URL = getApiUrl();
console.log(`Using API config for ${API_URL} environment`);

// URL pour le WebSocket du service de notification
export const SOCKET_URL = getSocketUrl();
console.log(`Using API config for SOCKET_URL ${SOCKET_URL}`);
